import React, { useState } from 'react';

import Button from '@mui/material/Button';

import Grid from '@mui/material/Grid';

import IssueReportModal from '../../../sharedModules/issueReports/components/IssueReportModal';

import { BackflowJobItem } from '../../model';

interface BackflowIssueReportProps {
  backflowJobItem: BackflowJobItem;
}

const BackflowIssueReport: React.FC<BackflowIssueReportProps> = (props) => {
  const { backflowJobItem } = props;

  const [reportDialogOpen, setReportDialogOpen] = useState<boolean>(false);

  return (
    <Grid container>
      <IssueReportModal
        reportableId={backflowJobItem?.id}
        reportableType="BackflowJobItem"
        reviewDialogOpen={reportDialogOpen}
        setReviewDialogOpen={setReportDialogOpen}
      />
      <Button variant="contained" color="secondary" onClick={() => setReportDialogOpen(true)}>
        Report Issue
      </Button>
    </Grid>
  );
};

export default BackflowIssueReport;
